enum SurveySearchByOptions {
  IDENTIFIER = 'identifier',
  REGNR = 'regnr',
  DOSSIER = 'dossier',
}

export default SurveySearchByOptions;
